export class CompiledDailyActiveUserConsumption {
  metric!: any;
  total!: number;
  planUsageRate!: number;
  exceededPlan!: number;
  planUsage!: number;
  availablePlan!: number;
  startDateReference!: Date;
  endDateReference!: Date;

  constructor(compiledDailyActiveUserConsumption: Partial<CompiledDailyActiveUserConsumption>) {
    Object.assign(this, compiledDailyActiveUserConsumption);

    this.startDateReference =
      this.startDateReference instanceof Date ? this.startDateReference : new Date(this.startDateReference);

    this.endDateReference =
      this.endDateReference instanceof Date ? this.endDateReference : new Date(this.endDateReference);
  }
}
